import React, { useEffect, useState } from 'react';
import { Image } from '@chakra-ui/react';

const FADE_MS = 1000;
const MIN_SLIDE_MS = 1000;
const MAX_SLIDE_MS = 2000;

const randomSlideDelay = () =>
  MIN_SLIDE_MS + Math.random() * (MAX_SLIDE_MS - MIN_SLIDE_MS);

const RewardSetFadeSlideshow = ({ slides, altFallback }) => {
  const [index, setIndex] = useState(() =>
    slides.length > 1 ? Math.floor(Math.random() * slides.length) : 0
  );

  useEffect(() => {
    setIndex(slides.length > 1 ? Math.floor(Math.random() * slides.length) : 0);
  }, [slides]);

  useEffect(() => {
    if (slides.length <= 1) return undefined;

    let cancelled = false;
    let timeoutId;

    const scheduleNext = () => {
      timeoutId = setTimeout(() => {
        if (cancelled) return;
        setIndex((prev) => (prev + 1) % slides.length);
        scheduleNext();
      }, randomSlideDelay());
    };

    scheduleNext();

    return () => {
      cancelled = true;
      clearTimeout(timeoutId);
    };
  }, [slides]);

  if (!slides.length) return null;

  return (
    <>
      {slides.map((slide, i) => {
        const active = i === index;
        return (
          <Image
            key={slide.id || slide.src}
            src={slide.src}
            alt={slide.alt || altFallback || ''}
            position="absolute"
            inset={0}
            w="full"
            h="full"
            objectFit="cover"
            opacity={active ? 1 : 0}
            transition={`opacity ${FADE_MS}ms ease-in-out`}
            zIndex={active ? 1 : 0}
            pointerEvents="none"
          />
        );
      })}
    </>
  );
};

export default RewardSetFadeSlideshow;
